import React from 'react'
import Forgot_Pass_Comp from './Forgot_Pass_Comp'

const Forgot_Pass = () => {
  return <Forgot_Pass_Comp/>
}

export default Forgot_Pass